module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h1', {
    staticClass: "tocchaptitle"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/06_introduction#intro"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_chapter01#c1"
    }
  }, [_c('b', [_vm._v("1 WHAT JUST HAPPENED?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/07_chapter01#c11"
    }
  }, [_vm._v("LIFE BEYOND THE DIAGNOSIS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/08_chapter02#c2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2 MANIA, DEPRESSION, PSYCHOSIS, OH MY!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/08_chapter02#c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A WHIRLWIND TOUR THROUGH THE EPISODES OF BIPOLAR DISORDER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/09_chapter03#c3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3 YOU'VE GOT DRUGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/09_chapter03#c31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WRAPPING YOUR HEAD AROUND MEDS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter04#c4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4 SHRINKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter04#c41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT THEY'RE FOR AND HOW THEY CAN HELP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter05#c5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5 THIS IS YOUR MANAGER SPEAKING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter05#c51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TAMING EPISODES WITH FOOD, SLEEP, AND EXERCISE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter06#c6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6 GRACE UNDER FIRE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter06#c61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KEEPING A COOL HEAD IN CRAPPY SITUATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter07#c7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7 HERE BE DOWNERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter07#c71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DRUGS, BOOZE, AND SUICIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter08#c8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8 THE GAME OF LIFE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter08#c81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIPOLAR IN COLLEGE AND AT WORK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter09#c9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9 VOICES NOT IN YOUR HEAD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter09#c91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEALING WITH FRIENDS AND FAMILY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10 HIPPIE SHIT THAT ACTUALLY WORKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter10#c101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HERBS, WILDERNESS TIME, AND OTHER WAYS TO HELP YOURSELF KEEP YOUR SHIT TOGETHER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11 HELL IS FINDING GOOD INSURANCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter11#c111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOW TO GET YOUR ASS COVERED IN TROUBLED TIMES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/18_conclusion#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONCLUSION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/19_resources#res",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RESOURCES")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350067dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_contents.vue
// module id = 72
// module chunks = 0